<template>
    <div class="textCenter">
        <h2>Transformez Votre</h2>
      </div>
      <div class="textWrapper">
        <h2
          v-for="(word, index) in words"
          :key="index"
          :class="{ active: index === currentIndex }"
          class="textYellow word"
        >
          {{ word }}
        </h2>
      </div>
</template>
<script setup>

import { ref, onMounted, onUnmounted } from 'vue';


const words = ["Histoire", "Vision", "Création", "Souvenir", "Rêve"];

const currentIndex = ref(0);

const updateWord = () => {
  currentIndex.value = (currentIndex.value + 1) % words.length; 
};

let interval;
onMounted(() => {
  interval = setInterval(updateWord, 1500); // Changer toutes les 2 secondes
});

// Nettoyer l'intervalle
onUnmounted(() => {
  clearInterval(interval);
});

</script>
<style lang="scss" scoped>
@import '../assets/main.css';

.textWrapper {
  position: relative;
  height: 6vh;
  overflow: hidden;
}

.word {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  text-align: center;
  transform: translateY(100%);
  opacity: 0;
  transition: transform 0.5s ease, opacity 0s ease;
}

.word.active {
  transform: translateY(0);
  opacity: 1;
}

.word:not(.active) {
  opacity: 0;
}

</style>